<template>
  <div>
    <fieldset>
      <legend>
        {{ $t('Add your business details') }}
      </legend>

      <CompanyDeBusinessEntityDetailsForm
        v-model:business-entity="internalBusinessEntity"
        :require-company-no="requireCompanyNo"
      />
    </fieldset>

    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <SubmitButton :text="$t('Save')" auto-submit class="tw-mt-5" />
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { ref } from 'vue'
import CompanyDeBusinessEntityDetailsForm from '@/components/compliances/BusinessEntity/De/CompanyDeBusinessEntityDetailsForm.vue'

export default {
  name: 'CompanyDeBusinessEntityForm',
  components: {
    CompanyDeBusinessEntityDetailsForm,
  },
  props: {
    businessEntity: {
      type: Object,
      required: true,
    },
    // Staffing agencies require a company registration number; companies don't.
    requireCompanyNo: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const v$ = useVuelidate()
    const internalBusinessEntity = ref(props.businessEntity)

    return {
      internalBusinessEntity,
      v$,
    }
  },
}
</script>
